import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import md5 from 'md5';

// tslint:disable-next-line: no-var-requires
const fallbackUrl = require('!!file-loader!./avatar-fallback.svg')

@Component
export default class extends Vue {
  url = fallbackUrl

  @Prop({ default: 128 })
  size!: number

  @Prop({ default: false })
  useGravatar!: boolean

  @Prop()
  email?: string

  @Watch('useGravatar', { immediate: true })
  onGravatarChange() {
    if (this.useGravatar) {
      if (this.email) {
        const img = new Image()
        const url =
          `${location.protocol}//www.gravatar.com/avatar/${md5(this.email!.toLowerCase())}?d=404&s=${this.size}`
        img.onload = () => this.url = url
        img.onerror = () => this.url = fallbackUrl
        img.src = url
      }
    } else {
      this.url = fallbackUrl
    }
  }

  get style() {
    const s = this.size
    return {
      width: `${s}px`,
      height: `${s}px`,
      backgroundColor: 'rgba(191, 191, 191, 0.75)',
    }
  }
}
